import React, { Component } from 'react'

export default class ButtonToggle extends Component {
  constructor ( props ) {
    super( props );
  }

  _handleChange () {
    this.props.handleChange(!this.props.isChecked);
  }

  render () {
    const {isChecked} = this.props
    return(
      <div className={"buttontoggle"}>
        <div className="buttontoggle-switch-container">
          <label>
            <input ref="switch" checked={isChecked} onChange={e => this._handleChange(e)} className="switch" type="checkbox" />
            <div>
              <div></div>
            </div>
          </label>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/controls/_ButtonToggle.js